/**
 * Hardcoded Season 1 Tournament Bracket Data
 *
 * This file contains the complete bracket data for Season 1 playoffs.
 * The PowerStats API endpoint returns incomplete data (NULL scores), so this
 * hardcoded data ensures the Season 1 bracket displays correctly.
 *
 * Tournament: Double Elimination - 8 Teams
 * Winner: Avanti NXT
 * Runner-up: Hedensted X SERA Talent
 */

export interface Season1Match {
  matchId: string;
  team1: {
    name: string;
    id: string;
    seed: number;
    logo?: string;
  };
  team2: {
    name: string;
    id: string;
    seed: number;
    logo?: string;
  };
  score1: number | null;
  score2: number | null;
  winner: string | null; // Team name of winner
  matchType: 'BO1' | 'BO3';
  maps: string[];
  roundNumber: number;
  bracketPosition: number; // Position in the bracket visualization (1-14)
  timestamp?: string;
}

export const SEASON_1_BRACKET_DATA: Season1Match[] = [
  // UPPER BRACKET - ROUND 1 (BO1)
  {
    matchId: '24',
    team1: { name: 'Prestige Esport Cheetah', id: '24-team1', seed: 3 },
    team2: { name: 'Avanti Academy', id: '24-team2', seed: 8 },
    score1: 1,
    score2: 0,
    winner: 'Prestige Esport Cheetah',
    matchType: 'BO1',
    maps: ['Vertigo'],
    roundNumber: 5,
    bracketPosition: 1
  },
  {
    matchId: '27',
    team1: { name: 'Hedensted X SERA Talent', id: '27-team1', seed: 2 },
    team2: { name: 'Rising Stars Selected', id: '27-team2', seed: 5 },
    score1: 0,
    score2: 1,
    winner: 'Rising Stars Selected',
    matchType: 'BO1',
    maps: ['Dust2'],
    roundNumber: 5,
    bracketPosition: 2
  },
  {
    matchId: '25',
    team1: { name: 'Avanti NXT', id: '25-team1', seed: 4 },
    team2: { name: 'AMO Esport', id: '25-team2', seed: 7 },
    score1: 1,
    score2: 0,
    winner: 'Avanti NXT',
    matchType: 'BO1',
    maps: ['Vertigo'],
    roundNumber: 5,
    bracketPosition: 3
  },
  {
    matchId: '26',
    team1: { name: 'Powerstats', id: '26-team1', seed: 1 },
    team2: { name: 'Unsigned Criminals', id: '26-team2', seed: 6 },
    score1: 1,
    score2: 0,
    winner: 'Powerstats',
    matchType: 'BO1',
    maps: ['Inferno'],
    roundNumber: 5,
    bracketPosition: 4
  },

  // UPPER BRACKET - ROUND 2 (BO1)
  {
    matchId: '28',
    team1: { name: 'Prestige Esport Cheetah', id: '28-team1', seed: 3 },
    team2: { name: 'Rising Stars Selected', id: '28-team2', seed: 5 },
    score1: 1,
    score2: 0,
    winner: 'Prestige Esport Cheetah',
    matchType: 'BO1',
    maps: ['Nuke'],
    roundNumber: 6,
    bracketPosition: 7
  },
  {
    matchId: '29',
    team1: { name: 'Avanti NXT', id: '29-team1', seed: 4 },
    team2: { name: 'Powerstats', id: '29-team2', seed: 1 },
    score1: 1,
    score2: 0,
    winner: 'Avanti NXT',
    matchType: 'BO1',
    maps: ['Nuke'],
    roundNumber: 6,
    bracketPosition: 8
  },

  // UPPER BRACKET - FINAL (BO3)
  {
    matchId: '41',
    team1: { name: 'Avanti NXT', id: '41-team1', seed: 4 },
    team2: { name: 'Prestige Esport Cheetah', id: '41-team2', seed: 3 },
    score1: 2,
    score2: 0,
    winner: 'Avanti NXT',
    matchType: 'BO3',
    maps: ['Ancient', 'Nuke'],
    roundNumber: 10,
    bracketPosition: 12
  },

  // LOWER BRACKET - ROUND 1 (BO3)
  {
    matchId: '30',
    team1: { name: 'Avanti Academy', id: '30-team1', seed: 8 },
    team2: { name: 'Hedensted X SERA Talent', id: '30-team2', seed: 2 },
    score1: 0,
    score2: 2,
    winner: 'Hedensted X SERA Talent',
    matchType: 'BO3',
    maps: ['Inferno', 'Dust2'],
    roundNumber: 9,
    bracketPosition: 5
  },
  {
    matchId: '31',
    team1: { name: 'Unsigned Criminals', id: '31-team1', seed: 6 },
    team2: { name: 'AMO Esport', id: '31-team2', seed: 7 },
    score1: 1,
    score2: 2,
    winner: 'AMO Esport',
    matchType: 'BO3',
    maps: ['Anubis', 'Inferno', 'Vertigo'],
    roundNumber: 9,
    bracketPosition: 6
  },

  // LOWER BRACKET - ROUND 2 (BO3)
  {
    matchId: '33',
    team1: { name: 'Rising Stars Selected', id: '33-team1', seed: 5 },
    team2: { name: 'AMO Esport', id: '33-team2', seed: 7 },
    score1: 0,
    score2: 2,
    winner: 'AMO Esport',
    matchType: 'BO3',
    maps: ['Mirage', 'Anubis'],
    roundNumber: 11,
    bracketPosition: 9
  },
  {
    matchId: '34',
    team1: { name: 'Powerstats', id: '34-team1', seed: 1 },
    team2: { name: 'Hedensted X SERA Talent', id: '34-team2', seed: 2 },
    score1: 1,
    score2: 2,
    winner: 'Hedensted X SERA Talent',
    matchType: 'BO3',
    maps: ['Anubis', 'Inferno', 'Ancient'],
    roundNumber: 11,
    bracketPosition: 10
  },

  // LOWER BRACKET - ROUND 3 (BO3)
  {
    matchId: '42',
    team1: { name: 'AMO Esport', id: '42-team1', seed: 7 },
    team2: { name: 'Hedensted X SERA Talent', id: '42-team2', seed: 2 },
    score1: 0,
    score2: 2,
    winner: 'Hedensted X SERA Talent',
    matchType: 'BO3',
    maps: ['Dust2', 'Mirage'],
    roundNumber: 12,
    bracketPosition: 11
  },

  // LOWER BRACKET - FINAL (BO3)
  {
    matchId: '13',
    team1: { name: 'Hedensted X SERA Talent', id: '13-team1', seed: 2 },
    team2: { name: 'Prestige Esport Cheetah', id: '13-team2', seed: 3 },
    score1: 2,
    score2: 0,
    winner: 'Hedensted X SERA Talent',
    matchType: 'BO3',
    maps: ['Inferno', 'Nuke'],
    roundNumber: 13,
    bracketPosition: 13
  },

  // GRAND FINAL (BO3)
  {
    matchId: '47',
    team1: { name: 'Avanti NXT', id: '47-team1', seed: 4 },
    team2: { name: 'Hedensted X SERA Talent', id: '47-team2', seed: 2 },
    score1: 2,
    score2: 1,
    winner: 'Avanti NXT',
    matchType: 'BO3',
    maps: ['Inferno', 'Nuke', 'Ancient'],
    roundNumber: 14,
    bracketPosition: 14
  }
];

/**
 * Get match by bracket position (1-14)
 */
export function getSeason1MatchByPosition(position: number): Season1Match | undefined {
  return SEASON_1_BRACKET_DATA.find(match => match.bracketPosition === position);
}

/**
 * Get match by match ID
 */
export function getSeason1MatchById(matchId: string): Season1Match | undefined {
  return SEASON_1_BRACKET_DATA.find(match => match.matchId === matchId);
}
